import { Link } from "react-router-dom";

export default function SubscribeCta() {
  return (
    <section className="w-full bg-background-50 pb-16 md:pb-20">
      <div className="mx-auto w-full max-w-7xl px-4 md:px-6">
        <div className="relative overflow-hidden rounded-lg border border-accent-200 bg-accent-50">
          <div className="pointer-events-none absolute -right-10 -top-16 h-56 w-56 rounded-full bg-accent-200/50"></div>
          <div className="pointer-events-none absolute -bottom-20 -left-12 h-56 w-56 rounded-full bg-primary-100/70"></div>
          <div className="relative grid grid-cols-1 gap-8 p-6 md:grid-cols-[1.4fr_1fr] md:items-center md:p-10">
            <div>
              <p className="inline-flex items-center gap-2 rounded-full bg-background-50/70 px-3 py-1 font-label text-xs text-accent-800">
                <i className="ri-notification-3-line" aria-hidden="true"></i>
                事件简报
              </p>
              <h2 className="mt-4 font-heading text-2xl font-bold leading-snug text-foreground-950 md:text-3xl">
                重要进展，整理好再告诉你
              </h2>
              <p className="mt-4 max-w-xl font-body text-sm leading-relaxed text-foreground-700 md:text-base">
                不是每条更新都值得打扰。只有当事件出现新的公开进展、或者档案状态发生变化时，
                我们才会整理成一封简短简报发给你。
              </p>
            </div>
            <div className="flex flex-col gap-3">
              <Link to="/about#contact" className="btn-primary w-full">
                <i className="ri-mail-send-line" aria-hidden="true"></i>
                前往订阅与投稿
              </Link>
              <Link to="/topics" className="btn-secondary w-full border-accent-300 bg-background-50">
                先逛逛档案库
              </Link>
              <p className="text-center font-label text-xs text-foreground-500">
                我们只用邮箱发送简报，不做任何其他用途
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}